module.exports = __webpack_public_path__ + "img/treatment-triangle-light-mobile.e530500a.svg";